// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   TABLE WRAPPER (SAFE)
========================= */
.table-wrapper {
  overflow-x: auto;
  background: transparent; /* ❌ wrapper colour hata diya */
  border-radius: 12px;
  box-shadow: none;
}

/* =========================
   COMMON TABLE BASE
========================= */
.common-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 700px;
  color: #e5e7eb;
}

/* =========================
   TABLE HEADER
========================= */
.common-table thead th {
  background: #020617;
  color: #9ca3af;
  font-weight: 600;
  font-size: 13px;
  padding: 14px 16px;
  text-align: left;
  border-bottom: 1px solid #1e293b;
  position: sticky;
  top: 0;
  z-index: 5;
}

/* =========================
   TABLE ROWS
========================= */
.common-table tbody tr {
  height: 56px;
}

/* CELLS */
.common-table td {
  padding: 14px 16px;
  font-size: 14px;
  background: linear-gradient(180deg, #020617, #0b1220);
  border-bottom: 1px solid #1e293b;
  white-space: nowrap;
  vertical-align: middle;
  color: #e5e7eb;
}

/* STRIPED ROW */
.common-table tbody tr:nth-child(even) td {
  background: #020617;
}

/* HOVER */
.common-table tbody tr:hover td {
  background: #020617;
  cursor: pointer;
}

/* =========================
   COMPACT TABLE
========================= */
.common-table.compact-table th,
.common-table.compact-table td {
  padding: 10px 14px;
  font-size: 13px;
}

.common-table.compact-table tr {
  height: 44px;
}

/* =========================
   STATUS
========================= */
.status-badge {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

/* =========================
   ACTION BUTTONS
========================= */
.action-btn {
  border: none;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}

.action-btn.view {
  background: #3b82f6;
  color: white;
}

.action-btn.edit {
  background: #facc15;
  color: #1e293b;
}

.action-btn.delete {
  background: #ef4444;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/Table.css"],"names":[],"mappings":"AAAA;;2BAE2B;AAC3B;EACE,gBAAgB;EAChB,uBAAuB,EAAE,+BAA+B;EACxD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;2BAE2B;AAC3B;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;2BAE2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;AACd;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,eAAe;EACf,qDAAqD;EACrD,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;2BAE2B;AAC3B;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;2BAE2B;AAC3B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":["/* =========================\n   TABLE WRAPPER (SAFE)\n========================= */\n.table-wrapper {\n  overflow-x: auto;\n  background: transparent; /* ❌ wrapper colour hata diya */\n  border-radius: 12px;\n  box-shadow: none;\n}\n\n/* =========================\n   COMMON TABLE BASE\n========================= */\n.common-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  min-width: 700px;\n  color: #e5e7eb;\n}\n\n/* =========================\n   TABLE HEADER\n========================= */\n.common-table thead th {\n  background: #020617;\n  color: #9ca3af;\n  font-weight: 600;\n  font-size: 13px;\n  padding: 14px 16px;\n  text-align: left;\n  border-bottom: 1px solid #1e293b;\n  position: sticky;\n  top: 0;\n  z-index: 5;\n}\n\n/* =========================\n   TABLE ROWS\n========================= */\n.common-table tbody tr {\n  height: 56px;\n}\n\n/* CELLS */\n.common-table td {\n  padding: 14px 16px;\n  font-size: 14px;\n  background: linear-gradient(180deg, #020617, #0b1220);\n  border-bottom: 1px solid #1e293b;\n  white-space: nowrap;\n  vertical-align: middle;\n  color: #e5e7eb;\n}\n\n/* STRIPED ROW */\n.common-table tbody tr:nth-child(even) td {\n  background: #020617;\n}\n\n/* HOVER */\n.common-table tbody tr:hover td {\n  background: #020617;\n  cursor: pointer;\n}\n\n/* =========================\n   COMPACT TABLE\n========================= */\n.common-table.compact-table th,\n.common-table.compact-table td {\n  padding: 10px 14px;\n  font-size: 13px;\n}\n\n.common-table.compact-table tr {\n  height: 44px;\n}\n\n/* =========================\n   STATUS\n========================= */\n.status-badge {\n  display: inline-block;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  background: rgba(34, 197, 94, 0.15);\n  color: #22c55e;\n}\n\n/* =========================\n   ACTION BUTTONS\n========================= */\n.action-btn {\n  border: none;\n  padding: 6px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.action-btn.view {\n  background: #3b82f6;\n  color: white;\n}\n\n.action-btn.edit {\n  background: #facc15;\n  color: #1e293b;\n}\n\n.action-btn.delete {\n  background: #ef4444;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
